import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditApi } from './audit.api';
import type { AuditLogFilters, AuditLogPage } from '@/types/api';

export const AUDIT_KEY = ['admin', 'audit'] as const;

export function useAuditLog(filters: AuditLogFilters, limit = 50, offset = 0) {
  return useQuery<AuditLogPage>({
    queryKey: [...AUDIT_KEY, filters, limit, offset],
    queryFn: () => auditApi.list(filters, limit, offset),
    staleTime: 10_000,
    placeholderData: keepPreviousData,
  });
}
